import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=2063cfcc&scoped=true"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
import style0 from "./Mail.vue?vue&type=style&index=0&id=2063cfcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063cfcc",
  null
  
)

export default component.exports